import React, { Fragment } from 'react';

import Button from '../../../../../components/Button';
import Table from '../../../../../components/_table/Table/Table';
import columns from './columns';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { OrderManagementItem } from '../../../../../types/multiChannel/orderManagement';
import { FilterOptions, Pagination } from '../../types';
import { OrderManagementListStyle } from './style';
import type { ColumnType } from 'antd/es/table';

interface OrderManagementListProps {
  totalCount: number;
  orderList: OrderManagementItem[];
  selectedCheckboxIds: string[];
  setSelectedCheckboxIds: (data: string[]) => void;
  pagination: Pagination;
  changePagination: (data: Pagination) => void;
  cancelOrders: () => void;
  returnOrders: () => void;
  readyOrders: () => void;
  downloadTotalExcel: () => void;
  downloadSelectedExcel: () => void;
}
const OrderManagementList = (props: OrderManagementListProps): JSX.Element => {
  const {
    totalCount,
    orderList,
    selectedCheckboxIds,
    setSelectedCheckboxIds,
    pagination,
    changePagination,
    cancelOrders,
    returnOrders,
    readyOrders,
    downloadTotalExcel,
    downloadSelectedExcel,
  } = props;

  return (
    <OrderManagementListStyle
      head={
        <div className="excel-btn-area">
          <Button isRadius={true} text="선택 주문 엑셀 다운로드" onClick={downloadSelectedExcel} />
          <Button isRadius={true} text="전체 주문 엑셀 다운로드" onClick={downloadTotalExcel} />
        </div>
      }
      body={
        <Fragment>
          <div className="order-management-list-body-area">
            <div className="row">
              <div className="button-form">
                <div className="label">주문확인</div>
                <div className="button-list">
                  <Button text="상품 준비" onClick={readyOrders} />
                </div>
              </div>
              <div className="button-form">
                <div className="label">주문 반품</div>
                <div className="button-list">
                  <Button text="반품 처리" onClick={returnOrders} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="button-form">
                <div className="label">주문 취소</div>
                <div className="button-list">
                  <Button text="주문 취소" onClick={cancelOrders} />
                </div>
              </div>
            </div>
          </div>

          <Table
            className="order-management-list-table"
            rowKey={(record: OrderManagementItem): string => record.id}
            list={orderList}
            onCheck={setSelectedCheckboxIds}
            selectedList={selectedCheckboxIds}
            initialOption={{
              pagination: _LIST_PAGINATION_MODEL,
            }}
            pagination={{
              ...pagination,
              totalCnt: totalCount,
            }}
            getList={({ pagination }: FilterOptions): void => {
              changePagination(pagination);
            }}
            scroll={{ x: true }}
            columns={(): ColumnType<OrderManagementItem>[] => columns()}
          />
        </Fragment>
      }
    />
  );
};

export default OrderManagementList;
